var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartFrame',{attrs:{"title":_vm.$t('Chart__DoctorsPerSector__name')}},[_c('ApexChart',{attrs:{"options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }